export function arrayToRecord<T>(a: T[], keyName: string): Record<string, T[]> {
  const result: Record<string, T[]> = {}
  a.forEach((i) => {
    const entry = result[(i as any)[keyName]] ?? []
    entry.push(i)
    result[(i as any)[keyName]] = entry
  })
  return result
}
